<template>
  <label
    class="app-data-filter__group-item app-data-filter__group-item--radio"
    :class="{ 'app-data-filter__group-item--radio-checked': isChecked }"
  >
    <input v-model="model" type="radio" :value="valueAsScalar" @click="uncheck" />
    <span class="app-data-filter__group-item-title item-label">{{ title }}</span>
    <TheCheckedMarkIcon class="app-data-filter__group-item-icon-checked" />
  </label>
</template>

<script>
import { isObject } from '@/helpers/common';
import { getItemValueAsScalar } from '@/helpers/data-filter/utils';
import TheCheckedMarkIcon from '@/components/icons/TheCheckedMarkIcon.vue';

export default {
  name: 'AppDataFilterRadioGroupItem',
  components: { TheCheckedMarkIcon },
  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    item: {
      type: [String, Number, Boolean, Object],
      required: true,
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: null,
    },
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('change', value);
      },
    },
    valueAsScalar() {
      return isObject(this.item) ? getItemValueAsScalar(this.item) : this.item;
    },
    isChecked() {
      return this.valueAsScalar === this.value;
    },
    title() {
      return isObject(this.item) ? this.item.title : this.item;
    },
  },

  methods: {
    uncheck() {
      if (this.value !== null && this.isChecked) {
        this.$emit('change', null);
      }
    },
  },
};
</script>
